module.exports = __webpack_public_path__ + "img/12-9.c525d254.png";